module.exports = __webpack_public_path__ + "img/Poly 2.jpg";